import { render, staticRenderFns } from "./GraficoVendasSemanal.vue?vue&type=template&id=0b1492fa&"
import script from "./GraficoVendasSemanal.vue?vue&type=script&setup=true&lang=js&"
export * from "./GraficoVendasSemanal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GraficoVendasSemanal.vue?vue&type=style&index=0&id=0b1492fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports